"use client";

import { useCallback, useRef, type ComponentType } from "react";

import { HomeGraphicShell } from "./home-graphic-shell";
import { preloadImages } from "./preload";

type SceneProps = { play: boolean };

export function OptimizeGraphic() {
	const sceneRef = useRef<ComponentType<SceneProps> | null>(null);

	const onApproach = useCallback(async () => {
		const mod = await import("./optimize-scene");
		await preloadImages(mod.OPTIMIZE_ASSET_PRELOAD);
		sceneRef.current = mod.OptimizeScene;
	}, []);

	return (
		<HomeGraphicShell width={640} height={485} bleed={72} onApproach={onApproach}>
			{({ play, ready }) => {
				const Scene = sceneRef.current;
				return ready && Scene ? <Scene play={play} /> : null;
			}}
		</HomeGraphicShell>
	);
}
